import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { ConnectionService } from './connection.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProofService {

  constructor(private http: HttpClient, private connectionService: ConnectionService) {}

  public findPendingEvidence(category: string) {

    return this.http.post(this.connectionService.address + '/evidence-service/find-pending-evidence',
    {
      find: {
        category
      },
      start: 0,
      limit: 0,
      sort: "amount"
    });
  }

  public submitPendingEvidence(evidence: File, category: string) {
    const formData: FormData = new FormData();
    formData.append('evidence', evidence);
    formData.append('category', category);

    return this.http.post(this.connectionService.address + '/evidence-service/upload-pending-evidence', formData, {
      reportProgress: true,
      observe: 'events'
    });    
  }

  public clearPendingEvidence() {
    
    return this.http.post(this.connectionService.address + '/evidence-service/clear-pending-evidence', {});
  }

  public submitProof (proof: File[], transactionHash: string) {

    const formData: FormData = new FormData();
    formData.append('evidence', proof[0]);
    formData.append('transaction', transactionHash);

    return this.http.post(this.connectionService.address + '/proof-service/upload-proof', formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public deleteProof (transactionHash: string, proofHash: string) {
    return this.http.post(this.connectionService.address + '/proof-service/delete-proof', {
      proofHash,
      transactionHash
    });
  }

  public loadSourceFile(transactionHash: string, proofHash: string) {
    const headers = new HttpHeaders({'Accept':'*'});

    return this.http.get(
      this.connectionService.address + "/proof-service/view?transactionHash="+transactionHash+"&proofHash="+proofHash,
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }).pipe(
        map((result: HttpResponse<Blob>) => {
          return result.headers.get("content-type");
        })
      )
  }

  public loadPendingEvidence(evidence: { file: string; }) {
    const headers = new HttpHeaders({'Accept':'*'});

    return this.http.get(
      this.connectionService.address + "/evidence-service/view-pending-evidence?filename="+evidence.file,
      {
        headers,
        responseType: 'blob',
        observe: 'response'
      }).pipe(
        map((result: HttpResponse<Blob>) => {
          return result.headers.get("content-type");
        })
      )
  }

  public updatePendingEvidence(pendingEvidence: any) {
    console.log(pendingEvidence);
    return this.http.post(this.connectionService.address + '/evidence-service/update-pending-evidence', 
    {
      pendingEvidence
    });
  }

  public doesEvidenceAlreadyExist(pendingEvidence: any) {
    return this.http.post(this.connectionService.address + '/evidence-service/does-evidence-already-exist', 
    {
      pendingEvidence
    });
  }

  public applyPendingEvidence(pendingEvidence: { file: string; } | undefined, transaction: string) {
    return this.http.post(this.connectionService.address + '/evidence-service/apply-pending-evidence',
    {
      pendingEvidence,
      transaction
    });
  }

  public deletePendingEvidence(pendingEvidence: any) {
    return this.http.post(this.connectionService.address + '/evidence-service/delete-pending-evidence',
    {
      pendingEvidence
    });
  }
}
